module.exports = __webpack_public_path__ + "static/portfolios-of-the-poor-804ab6f4138ebc1d64258f8fda867fa6.jpg";